var map = {
	"./de-de.png": "5a26",
	"./en-gb.png": "71d7",
	"./en-us.png": "e839",
	"./es-es.png": "3b1a",
	"./fr-fr.png": "008a",
	"./it-it.png": "b341",
	"./nl-nl.png": "04c0",
	"./pl-pl.png": "e3aa",
	"./pt-pt.png": "a542"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61f4";